import { render, staticRenderFns } from "./BootstrapModal.vue?vue&type=template&id=4b121e04&scoped=true&"
import script from "./BootstrapModal.vue?vue&type=script&lang=js&"
export * from "./BootstrapModal.vue?vue&type=script&lang=js&"
import style0 from "./BootstrapModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BootstrapModal.vue?vue&type=style&index=1&id=4b121e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b121e04",
  null
  
)

export default component.exports